import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  getUserNameByGId,
  resetPassword,
  putUserSignOpt,
  putUserLogin,
} from "../handler/LoginAndSingupHandler";
import axios from "axios";
import { Alert } from "@mui/material";
import UserLoader from "../Dashboard/UserLoader";

type LoginAndSignupPopupProps = {
  onClose: () => void;
};

type State = {
  name: string;
  state_code: string;
};

const LoginAndSignupPopup: React.FC<LoginAndSignupPopupProps> = ({
  onClose,
}) => {
  const [activeTab, setActiveTab] = useState("login");

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const [userName, setUserName] = useState("");
  const [loginUserName, setLoginUserName] = useState("");

  const [userNameError, setUserNameError] = useState("");
  const [loginNameError, setloginNameError] = useState("");

  const [loginUserValid, setLoginUserValid] = useState(false);

  const [formData, setFormData] = useState<Record<string, any>>({});
  const [singUpData, setSingUpData] = useState<Record<string, any>>({});

  const [invalidPassword, setInvalidPassword] = useState(false);

  const passwordRegex =
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;

  const [isValid, setIsValid] = useState(false);
  const [isMatch, setIsMatch] = useState(false);

  const [password, setPassowrd] = useState("");
  const [confirmPassword, setConfirmPassowrd] = useState("");

  const [states, setStates] = useState<State[]>([]);
  const [loadingStates] = useState(false);

  const [loader, setLoader] = useState(false);

  const [forgetEmailId, setForgetEmailId] = useState("");
  const [resetRequestSend, setResetRequestSend] = useState(false);

  const [resetUserName, setResetUserName] = useState("");
  const [resetUserError, setResetUserError] = useState("");
  const [resetUserValid, setResetUserValid] = useState(false);

  const [isEmailValid, setIsEmailValid] = useState(false);

  const [sponsorGrowniverseId, setSponsorGrowniverseId] = useState("");

  const location = useLocation();

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const runOnce = useRef(false);

  /* ---------------------------------------------------------
     PASSWORD
  --------------------------------------------------------- */

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible((prev) => !prev);
  };

  const checkValidPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputPassword = event.target.value;

    setPassowrd(inputPassword);

    const valid = passwordRegex.test(inputPassword);

    setIsValid(valid);

    setIsMatch(
      confirmPassword.length > 0 && confirmPassword === inputPassword
    );

    handleSignUpChange(event);
  };

  const checkConfirmPassword = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const inputPassword = event.target.value;

    setConfirmPassowrd(inputPassword);

    setIsMatch(password === inputPassword && inputPassword.length > 0);
  };

  /* ---------------------------------------------------------
     LOGIN
  --------------------------------------------------------- */

  const getUserNameByGID = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoader(true);

    const growniverseid = event.target.value;

    if (growniverseid.length > 0) {
      try {
        const response = await getUserNameByGId(growniverseid);

        if (response.success) {
          setLoginUserName(response.data.fullName);
          setloginNameError("");
          setLoginUserValid(true);
        } else {
          setloginNameError(response.message);
          setLoginUserName("");
          setLoginUserValid(false);
        }
      } catch (error) {
        console.error(error);
        setloginNameError("Unable to verify Growniverse ID.");
        setLoginUserValid(false);
      }
    } else {
      setLoginUserName("");
      setLoginUserValid(false);
      setloginNameError("");
    }

    setLoader(false);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "Password") {
      setInvalidPassword(false);
    }
  };

  const loginClick = async (event: React.FormEvent) => {
    event.preventDefault();

    localStorage.clear();
    setLoader(true);

    try {
      const response = await putUserLogin(formData);

      if (response.statusCode === 200) {
        const userData = response.data.loginResponse;

        localStorage.setItem("appkey", userData.appKey);
        localStorage.setItem(
          "userProfile",
          JSON.stringify(userData.profile)
        );
        localStorage.setItem(
          "account",
          JSON.stringify(userData.account)
        );
        localStorage.setItem(
          "HeighestEarnerWeek",
          JSON.stringify(userData.heighestEarnerOfWeekDtos)
        );

        if (userData.profile.isAdmin) {
          window.location.href = "/packagepayment";
        } else {
          if (userData.profile.packageId === 0) {
            localStorage.setItem(
              "packages",
              JSON.stringify(userData.packages)
            );

            if (userData.profile.status === 2) {
              window.location.href = "/package";
            } else if (userData.profile.status === 3) {
              window.location.href = "/hold";
            } else {
              window.location.href = "/profile";
            }
          } else if (userData.profile.affiliateApproved) {
            window.location.href = "/dashboard";
          } else {
            window.location.href = "/mycourses";
          }
        }
      } else if (response.statusCode === 401) {
        setInvalidPassword(true);
        setLoader(false);
      } else if (response.statusCode === 405) {
        localStorage.setItem("appkey", "NeedVerification");
        localStorage.setItem("data", JSON.stringify(response));

        window.location.href = "/emailConfirmation";
      } else {
        setInvalidPassword(true);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      setInvalidPassword(true);
      setLoader(false);
    }
  };

  /* ---------------------------------------------------------
     REGISTER
  --------------------------------------------------------- */

  const handleSignUpChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === "Password") {
      setInvalidPassword(false);
    }

    if (name === "sponsorGrowniverseId") {
      setSponsorGrowniverseId(value);
    }

    setSingUpData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get(
        "https://countriesnow.space/api/v0.1/countries/states"
      );

      const selectedCountryData = response.data.data.find(
        (c: any) => c.name === "India"
      );

      if (selectedCountryData) {
        setStates(selectedCountryData.states);
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  const getUserNameByGIDEffelate = async (growniverseid: string) => {
    if (growniverseid.length > 0) {
      try {
        const response = await getUserNameByGId(growniverseid);

        if (response.success) {
          setUserName(response.data.fullName);
          setUserNameError("");
        } else {
          setUserNameError("Invalid Sponsor GrowniverseId");
          setUserName("");
        }
      } catch (error) {
        console.error(error);
        setUserNameError("Unable to verify sponsor ID.");
        setUserName("");
      }
    }
  };

  const getCheckEmail = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    const email = event.target.value;

    if (email.length > 0) {
      try {
        const response = await getUserNameByGId(email);

        if (response.success) {
          setIsEmailValid(true);
        } else {
          setIsEmailValid(false);
        }
      } catch {
        setIsEmailValid(false);
      }
    } else {
      setIsEmailValid(false);
    }
  };

  const userSingOpt = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!isValid) {
      return;
    }

    if (!isMatch) {
      return;
    }

    if (isEmailValid) {
      return;
    }

    setLoader(true);
    localStorage.clear();

    try {
      const response = await putUserSignOpt(singUpData);

      if (response.statusCode === 201) {
        localStorage.setItem("appkey", response.data.userId);

        window.location.href = "/emailconfirmation";
      } else {
        setLoader(false);

        alert(
          "An unexpected error occurred. Please try again."
        );
      }
    } catch (error) {
      console.error(error);
      setLoader(false);

      alert(
        "Unable to create your account. Please try again."
      );
    }
  };

  /* ---------------------------------------------------------
     FORGOT PASSWORD
  --------------------------------------------------------- */

  const handleChangeForgetInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setForgetEmailId(event.target.value);
  };

  const getUserNameByEmail = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    const growniverseEmail = event.target.value;

    if (growniverseEmail.length > 0) {
      try {
        const response = await getUserNameByGId(growniverseEmail);

        if (response.success) {
          setResetUserName(response.data.fullName);
          setResetUserError("");
          setResetUserValid(true);
        } else {
          setResetUserError(response.message);
          setResetUserName("");
          setResetUserValid(false);
        }
      } catch {
        setResetUserError("Email not found");
        setResetUserName("");
        setResetUserValid(false);
      }
    }
  };

  const forgetPassword = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!resetUserValid) return;

    setLoader(true);

    try {
      await resetPassword({
        emailId: forgetEmailId,
        resetChange: 1,
        newPasswordToken: "",
        newPassword: "",
      });

      setResetRequestSend(true);
    } catch (error) {
      console.error(error);
    }

    setLoader(false);
  };

  /* ---------------------------------------------------------
     INITIALIZATION
  --------------------------------------------------------- */

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (!runOnce.current) {
      const sponserGID = query.get("affiliatelink");

      if (sponserGID) {
        setActiveTab("register");
        setSponsorGrowniverseId(sponserGID);

        getUserNameByGIDEffelate(sponserGID);

        setSingUpData((prev) => ({
          ...prev,
          sponsorGrowniverseId: sponserGID,
        }));
      }

      runOnce.current = true;
    }
  }, [query]);

  /* ---------------------------------------------------------
     STYLES
  --------------------------------------------------------- */

  const styles = {
    overlay: {
      position: "fixed" as const,
      inset: 0,
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      background:
        "radial-gradient(circle at 15% 20%, rgba(0,255,255,.12), transparent 30%), radial-gradient(circle at 85% 80%, rgba(126,87,255,.18), transparent 30%), rgba(3,7,18,.88)",
      backdropFilter: "blur(16px)",
      overflowY: "auto" as const,
    },

    modal: {
      width: "100%",
      maxWidth: "760px",
      position: "relative" as const,
      borderRadius: "28px",
      overflow: "hidden",
      border: "1px solid rgba(0,255,255,.22)",
      background:
        "linear-gradient(145deg, rgba(11,20,40,.97), rgba(5,10,25,.98))",
      boxShadow:
        "0 0 0 1px rgba(255,255,255,.03), 0 30px 100px rgba(0,0,0,.65), 0 0 80px rgba(0,220,255,.10)",
    },

    glowTop: {
      position: "absolute" as const,
      top: "-150px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "500px",
      height: "300px",
      borderRadius: "50%",
      background:
        "radial-gradient(circle, rgba(0,229,255,.16), transparent 70%)",
      pointerEvents: "none" as const,
    },

    header: {
      position: "relative" as const,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "25px 30px 20px",
      borderBottom: "1px solid rgba(255,255,255,.07)",
    },

    logoArea: {
      display: "flex",
      alignItems: "center",
      gap: "13px",
    },

    logo: {
      width: "42px",
      height: "42px",
      borderRadius: "13px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "20px",
      fontWeight: 900,
      color: "#001018",
      background:
        "linear-gradient(135deg, #00f5ff, #6c63ff)",
      boxShadow:
        "0 0 25px rgba(0,245,255,.35)",
    },

    title: {
      margin: 0,
      color: "#fff",
      fontSize: "20px",
      fontWeight: 800,
      letterSpacing: "-.4px",
    },

    subtitle: {
      margin: "3px 0 0",
      color: "#71809b",
      fontSize: "11px",
      letterSpacing: "1px",
      textTransform: "uppercase" as const,
    },

    close: {
      width: "38px",
      height: "38px",
      borderRadius: "12px",
      border: "1px solid rgba(255,255,255,.1)",
      background: "rgba(255,255,255,.04)",
      color: "#94a3b8",
      cursor: "pointer",
      fontSize: "19px",
      transition: "all .2s ease",
    },

    body: {
      position: "relative" as const,
      padding: "25px 30px 30px",
    },

    tabs: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "6px",
      padding: "5px",
      marginBottom: "25px",
      borderRadius: "15px",
      background: "rgba(255,255,255,.035)",
      border: "1px solid rgba(255,255,255,.06)",
    },

    tab: {
      padding: "12px",
      borderRadius: "11px",
      border: "none",
      color: "#73819a",
      background: "transparent",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 700,
      transition: "all .25s ease",
    },

    activeTab: {
      color: "#00131b",
      background:
        "linear-gradient(135deg, #00eaff, #63f5d1)",
      boxShadow:
        "0 5px 20px rgba(0,234,255,.18)",
    },

    label: {
      display: "block",
      marginBottom: "8px",
      color: "#b8c5d9",
      fontSize: "12px",
      fontWeight: 700,
      letterSpacing: ".4px",
    },

    required: {
      color: "#ff557a",
    },

    input: {
      width: "100%",
      boxSizing: "border-box" as const,
      height: "46px",
      padding: "0 14px",
      borderRadius: "12px",
      outline: "none",
      border: "1px solid rgba(125,150,190,.18)",
      background: "rgba(255,255,255,.045)",
      color: "#eef8ff",
      fontSize: "13px",
      transition: "all .25s ease",
    },

    select: {
      width: "100%",
      height: "46px",
      padding: "0 14px",
      borderRadius: "12px",
      outline: "none",
      border: "1px solid rgba(125,150,190,.18)",
      background: "#0c1528",
      color: "#eef8ff",
      fontSize: "13px",
    },

    row: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "15px",
    },

    field: {
      marginBottom: "17px",
    },

    eyeButton: {
      position: "absolute" as const,
      right: "8px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "34px",
      height: "34px",
      border: "none",
      borderRadius: "9px",
      background: "rgba(255,255,255,.05)",
      color: "#8b9ab2",
      cursor: "pointer",
    },

    valid: {
      color: "#36e5ae",
      fontSize: "11px",
      marginTop: "7px",
    },

    invalid: {
      color: "#ff6687",
      fontSize: "11px",
      lineHeight: 1.5,
      marginTop: "7px",
    },

    successName: {
      display: "block",
      marginTop: "7px",
      color: "#36e5ae",
      fontSize: "12px",
      fontWeight: 700,
    },

    button: {
      width: "100%",
      height: "48px",
      border: "none",
      borderRadius: "13px",
      cursor: "pointer",
      color: "#00151b",
      fontWeight: 900,
      fontSize: "13px",
      letterSpacing: ".4px",
      background:
        "linear-gradient(135deg, #00eaff, #55e6b2)",
      boxShadow:
        "0 8px 30px rgba(0,230,255,.16)",
      transition: "all .25s ease",
    },

    secondaryButton: {
      border: "none",
      background: "transparent",
      color: "#6deeff",
      cursor: "pointer",
      fontSize: "12px",
      fontWeight: 700,
    },

    info: {
      marginBottom: "20px",
      padding: "12px 14px",
      borderRadius: "12px",
      border: "1px solid rgba(0,229,255,.14)",
      background: "rgba(0,229,255,.045)",
      color: "#9ecad4",
      fontSize: "11px",
      lineHeight: 1.6,
    },

    checkboxArea: {
      display: "flex",
      gap: "10px",
      alignItems: "flex-start",
      marginTop: "3px",
      marginBottom: "20px",
      color: "#7e8da5",
      fontSize: "11px",
      lineHeight: 1.6,
    },

    footerText: {
      textAlign: "center" as const,
      marginTop: "17px",
      color: "#66748b",
      fontSize: "12px",
    },

    link: {
      color: "#5eeeff",
      textDecoration: "none",
      fontWeight: 700,
    },

    divider: {
      height: "1px",
      background:
        "linear-gradient(90deg, transparent, rgba(255,255,255,.08), transparent)",
      margin: "20px 0",
    },

    loaderOverlay: {
      minHeight: "400px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    resetSuccess: {
      padding: "25px",
      borderRadius: "16px",
      border: "1px solid rgba(54,229,174,.2)",
      background: "rgba(54,229,174,.05)",
      color: "#b8ffe9",
      fontSize: "13px",
      lineHeight: 1.7,
      textAlign: "center" as const,
    },

    backButton: {
      display: "block",
      margin: "18px auto 0",
      border: "none",
      background: "transparent",
      color: "#5eeeff",
      cursor: "pointer",
      fontSize: "12px",
    },
  };

  /* ---------------------------------------------------------
     RENDER
  --------------------------------------------------------- */

  return (
    <>
      <div style={styles.overlay}>
        <div style={styles.modal}>
          <div style={styles.glowTop} />

          {/* HEADER */}
          <div style={styles.header}>
            <div style={styles.logoArea}>
              <div style={styles.logo}>G</div>

              <div>
                <h2 style={styles.title}>
                  Growniverse
                </h2>

                <p style={styles.subtitle}>
                  Secure Digital Access
                </p>
              </div>
            </div>

            <button
              type="button"
              onClick={onClose}
              style={styles.close}
              aria-label="Close"
            >
              ×
            </button>
          </div>

          {loader ? (
            <div style={styles.loaderOverlay}>
              <UserLoader />
            </div>
          ) : (
            <div style={styles.body}>
              {/* LOGIN / REGISTER TABS */}
              {activeTab !== "forgetpassword" && (
                <div style={styles.tabs}>
                  <button
                    type="button"
                    onClick={() => setActiveTab("login")}
                    style={{
                      ...styles.tab,
                      ...(activeTab === "login"
                        ? styles.activeTab
                        : {}),
                    }}
                  >
                    ◉ &nbsp; LOG IN
                  </button>

                  <button
                    type="button"
                    onClick={() => setActiveTab("register")}
                    style={{
                      ...styles.tab,
                      ...(activeTab === "register"
                        ? styles.activeTab
                        : {}),
                    }}
                  >
                    ✦ &nbsp; REGISTER
                  </button>
                </div>
              )}

              {/* =================================================
                  LOGIN
              ================================================= */}

              {activeTab === "login" && (
                <form onSubmit={loginClick}>
                  <div style={styles.field}>
                    <label style={styles.label}>
                      GROWNIVERSE ID{" "}
                      <span style={styles.required}>*</span>
                    </label>

                    <input
                      type="text"
                      value={formData["GrowniverseId"] || ""}
                      name="GrowniverseId"
                      onChange={handleInputChange}
                      onBlur={getUserNameByGID}
                      disabled={loginUserName.length > 0}
                      required
                      placeholder="Enter your Growniverse ID"
                      style={styles.input}
                    />

                    {loginUserName && (
                      <span style={styles.successName}>
                        ✓ {loginUserName}
                      </span>
                    )}

                    {loginNameError && (
                      <div style={{ marginTop: "10px" }}>
                        <Alert
                          severity="error"
                          variant="outlined"
                        >
                          Please enter a valid Growniverse ID
                        </Alert>
                      </div>
                    )}
                  </div>

                  <div style={styles.field}>
                    <label style={styles.label}>
                      PASSWORD{" "}
                      <span style={styles.required}>*</span>
                    </label>

                    <input
                      type="password"
                      name="Password"
                      onChange={handleInputChange}
                      disabled={!loginUserValid}
                      required
                      placeholder="Enter your password"
                      style={styles.input}
                    />

                    {invalidPassword && (
                      <div style={{ marginTop: "10px" }}>
                        <Alert
                          severity="error"
                          variant="outlined"
                        >
                          Invalid Password
                        </Alert>
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    style={{
                      ...styles.button,
                      opacity: loginUserValid ? 1 : 0.5,
                    }}
                    disabled={!loginUserValid}
                  >
                    ACCESS ACCOUNT &nbsp; →
                  </button>

                  <div style={{ textAlign: "center", marginTop: "16px" }}>
                    <button
                      type="button"
                      onClick={() =>
                        setActiveTab("forgetpassword")
                      }
                      style={styles.secondaryButton}
                    >
                      Forgot your password?
                    </button>
                  </div>

                  <div style={styles.divider} />

                  <div style={styles.footerText}>
                    New to Growniverse?{" "}
                    <button
                      type="button"
                      onClick={() => setActiveTab("register")}
                      style={{
                        ...styles.secondaryButton,
                        padding: 0,
                      }}
                    >
                      Create Account
                    </button>
                  </div>
                </form>
              )}

              {/* =================================================
                  REGISTER
              ================================================= */}

              {activeTab === "register" && (
                <form onSubmit={userSingOpt}>
                  <div style={styles.info}>
                    <strong>◈ IDENTITY VERIFICATION</strong>
                    <br />
                    Your registration details must exactly match
                    the information on your Aadhar Card.
                  </div>

                  <div style={styles.row}>
                    <div style={styles.field}>
                      <label style={styles.label}>
                        FULL NAME{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      <input
                        name="fullName"
                        type="text"
                        placeholder="Enter full name"
                        required
                        onChange={handleSignUpChange}
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>
                        PHONE NUMBER{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      <input
                        name="phoneNumber"
                        type="tel"
                        placeholder="Enter phone number"
                        required
                        onChange={handleSignUpChange}
                        style={styles.input}
                      />
                    </div>
                  </div>

                  <div style={styles.row}>
                    <div style={styles.field}>
                      <label style={styles.label}>
                        EMAIL ADDRESS{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      <input
                        name="email"
                        type="email"
                        placeholder="Enter email address"
                        required
                        onChange={handleSignUpChange}
                        onBlur={getCheckEmail}
                        style={{
                          ...styles.input,
                          borderColor: isEmailValid
                            ? "rgba(255,80,120,.7)"
                            : undefined,
                        }}
                      />

                      {isEmailValid && (
                        <div style={{ marginTop: "8px" }}>
                          <Alert
                            severity="error"
                            variant="outlined"
                          >
                            Mail-ID already exists. Please choose
                            another email.
                          </Alert>
                        </div>
                      )}
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>
                        DATE OF BIRTH{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      <input
                        name="dateOfBirth"
                        type="date"
                        max={
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() - 10
                            )
                          )
                            .toISOString()
                            .split("T")[0]
                        }
                        required
                        onChange={handleSignUpChange}
                        style={styles.input}
                      />
                    </div>
                  </div>

                  <div style={styles.row}>
                    <div style={styles.field}>
                      <label style={styles.label}>
                        COUNTRY
                      </label>

                      <select
                        disabled
                        value="India"
                        style={styles.select}
                      >
                        <option value="India">
                          India
                        </option>
                      </select>
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>
                        STATE{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      {loadingStates ? (
                        <div
                          style={{
                            color: "#6deeff",
                            fontSize: "12px",
                          }}
                        >
                          Loading states...
                        </div>
                      ) : (
                        <select
                          name="state"
                          disabled={!states.length}
                          required
                          onChange={handleSignUpChange}
                          style={styles.select}
                        >
                          <option value="">
                            Select State
                          </option>

                          {states.map((state, index) => (
                            <option
                              key={index}
                              value={state.state_code}
                            >
                              {state.name}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>

                  <div style={styles.row}>
                    <div style={styles.field}>
                      <label style={styles.label}>
                        ADDRESS{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      <input
                        name="address"
                        type="text"
                        placeholder="Enter address"
                        required
                        onChange={handleSignUpChange}
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>
                        PINCODE{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      <input
                        name="pincode"
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        placeholder="Enter pincode"
                        required
                        onChange={handleSignUpChange}
                        style={styles.input}
                      />
                    </div>
                  </div>

                  {/* PASSWORD */}
                  <div style={styles.row}>
                    <div style={styles.field}>
                      <label style={styles.label}>
                        PASSWORD{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      <div style={{ position: "relative" }}>
                        <input
                          type={
                            passwordVisible
                              ? "text"
                              : "password"
                          }
                          name="password"
                          placeholder="Create password"
                          required
                          onChange={checkValidPassword}
                          style={{
                            ...styles.input,
                            paddingRight: "52px",
                          }}
                        />

                        <button
                          type="button"
                          onClick={
                            togglePasswordVisibility
                          }
                          style={styles.eyeButton}
                        >
                          {passwordVisible ? "◉" : "◌"}
                        </button>
                      </div>
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>
                        CONFIRM PASSWORD{" "}
                        <span style={styles.required}>*</span>
                      </label>

                      <div style={{ position: "relative" }}>
                        <input
                          type={
                            confirmPasswordVisible
                              ? "text"
                              : "password"
                          }
                          placeholder="Confirm password"
                          required
                          disabled={!isValid}
                          onChange={checkConfirmPassword}
                          style={{
                            ...styles.input,
                            paddingRight: "52px",
                            opacity: isValid ? 1 : 0.5,
                          }}
                        />

                        <button
                          type="button"
                          onClick={
                            toggleConfirmPasswordVisibility
                          }
                          style={styles.eyeButton}
                        >
                          {confirmPasswordVisible
                            ? "◉"
                            : "◌"}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* PASSWORD VALIDATION */}
                  {password.length > 0 && (
                    <div
                      style={
                        isValid
                          ? styles.valid
                          : styles.invalid
                      }
                    >
                      {isValid ? (
                        <>✓ Password security requirements met.</>
                      ) : (
                        <>
                          Password must contain uppercase,
                          lowercase, number, special character,
                          no spaces, and be 8–16 characters.
                        </>
                      )}
                    </div>
                  )}

                  {confirmPassword.length > 0 && (
                    <div
                      style={
                        isMatch
                          ? styles.valid
                          : styles.invalid
                      }
                    >
                      {isMatch ? (
                        <>✓ Passwords match.</>
                      ) : (
                        <>✕ Passwords do not match.</>
                      )}
                    </div>
                  )}

                  {/* TERMS */}
                  <div style={styles.checkboxArea}>
                    <input
                      type="checkbox"
                      id="flexCheckDefault"
                      required
                      style={{
                        accentColor: "#00eaff",
                        marginTop: "3px",
                      }}
                    />

                    <label htmlFor="flexCheckDefault">
                      I agree to the{" "}
                      <Link
                        to="/privacypolicy"
                        target="_blank"
                        style={styles.link}
                      >
                        Privacy Policy
                      </Link>{" "}
                      and{" "}
                      <Link
                        to="/termsconditions"
                        target="_blank"
                        style={styles.link}
                      >
                        Terms & Conditions
                      </Link>
                      .
                    </label>
                  </div>

                  <button
                    type="submit"
                    disabled={
                      !isValid ||
                      !isMatch ||
                      isEmailValid
                    }
                    style={{
                      ...styles.button,
                      opacity:
                        !isValid ||
                        !isMatch ||
                        isEmailValid
                          ? 0.45
                          : 1,
                      cursor:
                        !isValid ||
                        !isMatch ||
                        isEmailValid
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    CREATE MY ACCOUNT &nbsp; ✦
                  </button>

                  <div style={styles.footerText}>
                    Already have an account?{" "}
                    <button
                      type="button"
                      onClick={() =>
                        setActiveTab("login")
                      }
                      style={{
                        ...styles.secondaryButton,
                        padding: 0,
                      }}
                    >
                      Sign In
                    </button>
                  </div>
                </form>
              )}

              {/* =================================================
                  FORGOT PASSWORD
              ================================================= */}

              {activeTab === "forgetpassword" && (
                <>
                  {!resetRequestSend ? (
                    <form onSubmit={forgetPassword}>
                      <div
                        style={{
                          textAlign: "center",
                          marginBottom: "25px",
                        }}
                      >
                        <div
                          style={{
                            width: "64px",
                            height: "64px",
                            margin: "0 auto 15px",
                            borderRadius: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "28px",
                            color: "#00eaff",
                            background:
                              "rgba(0,234,255,.08)",
                            border:
                              "1px solid rgba(0,234,255,.2)",
                            boxShadow:
                              "0 0 30px rgba(0,234,255,.08)",
                          }}
                        >
                          ↻
                        </div>

                        <h3
                          style={{
                            margin: 0,
                            color: "#fff",
                            fontSize: "19px",
                          }}
                        >
                          Reset Access
                        </h3>

                        <p
                          style={{
                            color: "#72809a",
                            fontSize: "12px",
                            lineHeight: 1.6,
                            marginTop: "8px",
                          }}
                        >
                          Enter your registered email address
                          and we'll send instructions to reset
                          your password.
                        </p>
                      </div>

                      <div style={styles.field}>
                        <label style={styles.label}>
                          REGISTERED EMAIL{" "}
                          <span style={styles.required}>
                            *
                          </span>
                        </label>

                        <input
                          type="email"
                          value={forgetEmailId}
                          onChange={handleChangeForgetInput}
                          onBlur={getUserNameByEmail}
                          disabled={resetUserName.length > 0}
                          required
                          placeholder="name@example.com"
                          style={styles.input}
                        />

                        {resetUserName && (
                          <span style={styles.successName}>
                            ✓ {resetUserName}
                          </span>
                        )}

                        {resetUserError &&
                          !resetUserValid && (
                            <div style={{ marginTop: "10px" }}>
                              <Alert
                                severity="error"
                                variant="outlined"
                              >
                                Mail-ID not found. Please check
                                the email address.
                              </Alert>
                            </div>
                          )}
                      </div>

                      <button
                        type="submit"
                        disabled={!resetUserValid}
                        style={{
                          ...styles.button,
                          opacity: resetUserValid
                            ? 1
                            : 0.45,
                          cursor: resetUserValid
                            ? "pointer"
                            : "not-allowed",
                        }}
                      >
                        SEND RESET INSTRUCTIONS &nbsp; →
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          setActiveTab("login")
                        }
                        style={styles.backButton}
                      >
                        ← Back to Login
                      </button>
                    </form>
                  ) : (
                    <div>
                      <div style={styles.resetSuccess}>
                        <div
                          style={{
                            fontSize: "40px",
                            marginBottom: "15px",
                            color: "#36e5ae",
                          }}
                        >
                          ✓
                        </div>

                        <h3
                          style={{
                            margin: "0 0 12px",
                            color: "#fff",
                          }}
                        >
                          Request Submitted
                        </h3>

                        <p style={{ margin: 0 }}>
                          Your password reset request has been
                          successfully submitted.
                          <br />
                          <br />
                          Please follow the instructions sent to
                          your registered email address to reset
                          your password.
                        </p>
                      </div>

                      <button
                        type="button"
                        onClick={() =>
                          setActiveTab("login")
                        }
                        style={styles.backButton}
                      >
                        ← Return to Login
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {/* =========================================================
          FUTURISTIC GLOBAL STYLES
      ========================================================= */}

      <style>
        {`
          * {
            box-sizing: border-box;
          }

          @keyframes futuristicPulse {
            0%, 100% {
              opacity: .5;
              transform: scale(1);
            }

            50% {
              opacity: 1;
              transform: scale(1.05);
            }
          }

          @keyframes futuristicFloat {
            0%, 100% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(-5px);
            }
          }

          input::placeholder {
            color: #52627a !important;
          }

          input:focus,
          select:focus {
            border-color: rgba(0, 234, 255, .65) !important;
            box-shadow:
              0 0 0 3px rgba(0, 234, 255, .07),
              0 0 25px rgba(0, 234, 255, .07) !important;
            background: rgba(0, 234, 255, .035) !important;
          }

          button {
            font-family: inherit;
          }

          button:hover:not(:disabled) {
            filter: brightness(1.1);
          }

          a {
            transition: all .2s ease;
          }

          ::-webkit-scrollbar {
            width: 5px;
          }

          ::-webkit-scrollbar-track {
            background: #050a16;
          }

          ::-webkit-scrollbar-thumb {
            background: #1c5260;
            border-radius: 10px;
          }

          @media (max-width: 650px) {
            .futuristic-modal {
              margin: 10px;
            }
          }

          @media (max-width: 560px) {
            .futuristic-row {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default LoginAndSignupPopup;
